import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-end gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-save"
}

import { ref } from 'vue';
import Button from 'primevue/button';
import DefaultInput from '../components/DefaultInput.vue';
import type { Calculation } from '../utils/types';
import { useSaveCalculation } from '../composables/useSaveCalculation';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationNameInput',
  props: {
    calculation: {}
  },
  setup(__props: any) {

const props = __props;

const { saveCalculation, isLoading } = useSaveCalculation();

const isEditing = ref(false);
const calculationName = ref(props.calculation.name);

async function handleSave() {
  await saveCalculation({
    ...props.calculation,
    name: calculationName.value,
  });

  isEditing.value = false;
}

function onClickOutside() {
  if (isEditing.value) {
    isEditing.value = false;
    calculationName.value = props.calculation.name;
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DefaultInput, {
      modelValue: calculationName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((calculationName).value = $event)),
      disabled: !isEditing.value
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" Nazwa kalkulacji ")
      ])),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    (!isEditing.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          severity: "secondary",
          icon: "",
          outlined: "",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isEditing.value = true), ["stop"]))
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "pi pi-pencil" }, null, -1)
          ])),
          _: 1
        }))
      : (_openBlock(), _createBlock(_unref(Button), {
          key: 1,
          severity: "secondary",
          disabled: calculationName.value.length < 4 || _unref(isLoading),
          icon: "",
          outlined: "",
          loading: _unref(isLoading),
          onClick: _withModifiers(handleSave, ["stop"])
        }, {
          default: _withCtx(() => [
            (_unref(isLoading))
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : (_openBlock(), _createElementBlock("i", _hoisted_3))
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
  ])), [
    [_directive_click_outside, onClickOutside]
  ])
}
}

})